export interface SessionState {
  isUnLocked: boolean;
}

export const initialState: SessionState = {
  isUnLocked: false,
};
